"use client";

const Banner = () => {
  return (
    <section className="w-full bg-white py-12 sm:py-16 ">
      <div className="mx-auto max-w-6xl px-5 sm:px-8 lg:px-10">

        {/* =====================================================
      HEADING
  ====================================================== */}
        <h2 className="mt-3 text-center text-3xl leading-tight text-edept-dark sm:text-4xl">
          Tuition and Estimated Costs
        </h2>

        {/* =====================================================
      COST COMPARISON
  ====================================================== */}
        <div className="mt-10">

          <div className="w-full bg-white py-4">
            <div className="mx-auto max-w-6xl px-6 lg:px-8">

              {/* Comparison Cards */}
              <div className="relative grid grid-cols-1 gap-6 md:grid-cols-2 md:gap-20">

                {/* VS Badge */}
                <div
                  className="
          absolute left-1/2 top-1/2 z-10
          hidden h-12 w-12 -translate-x-1/2 -translate-y-1/2
          items-center justify-center
          rounded-full border border-gray-200
          bg-white
          text-xs font-medium uppercase tracking-widest text-gray-400
          md:flex
        "
                >
                  VS
                </div>

                {/* Traditional / Full Program */}
                <div
                  className="
          rounded-2xl border border-gray-200
          bg-white
          px-7 py-8
          sm:px-10 sm:py-10
        "
                >
                  <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-gray-500">
                    Full Program
                  </p>

                  <h3 className="mt-3 font-serif text-2xl tracking-tight text-gray-900">
                    Illinois Tech Only
                  </h3>

                  <div className="mt-8 space-y-5">
                    
                    <div className="flex items-center justify-between gap-6">
                      <span className="text-base text-gray-600">
                        Duration
                      </span>

                      <span className="text-right font-mono text-base font-medium text-gray-900">
                        18–20 months in Chicago
                      </span>
                    </div>
                    <div className="flex items-center justify-between gap-6">
                      <span className="text-base text-gray-600">
                        Total Cost of Attendance
                      </span>

                      <span className="font-mono text-base font-medium text-gray-900">
                        $109,000
                      </span>
                    </div>
                  </div>

                  <div className="mt-10 border-t border-gray-200 pt-6">
                    <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-gray-500">
                      Tution Fee
                    </p>

                    <p className="mt-2 font-serif text-4xl tracking-tight text-gray-900 sm:text-5xl">
                      ~$63,525
                    </p>
                  </div>
                </div>

                {/* 1+1 Pathway */}
                <div
                  className="
          relative rounded-2xl
          border border-[#12539F]
          bg-[#F3F8FD]
          px-7 py-8
          sm:px-10 sm:py-10
        "
                >
                  {/* Savings Badge */}
                  <div
                    className="
            absolute -right-1 -top-4
            rounded-full
            bg-[#F5A623]
            px-5 py-2
            font-mono text-[11px]
            font-medium uppercase
            tracking-[0.15em]
            text-[#111827]
            shadow-[0_6px_18px_rgba(0,0,0,0.12)]
            sm:-right-1
          "
                  >
                    Save $30,500
                  </div>

                  <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-[#12539F]">
                    1+1 Pathway
                  </p>

                  <h3 className="mt-3 font-serif text-2xl tracking-tight text-gray-900">
                    India + Chicago
                  </h3>

                  <div className="mt-8 space-y-5">

                    <div className="flex items-center justify-between gap-6">
                      <span className="text-base text-gray-600">
                        Duration
                      </span>

                      <span className="text-right font-mono text-base font-medium text-gray-900">
                        6 months in India <br />+ 12 months in Chicago
                      </span>
                    </div>
                    <div className="flex items-center justify-between gap-6">
                      <span className="text-base text-gray-600">
                        Total Cost of Attendance
                      </span>

                      <span className="font-mono text-base font-medium text-gray-900">
                        ~$78,500
                      </span>
                    </div>
                  </div>

                  <div className="mt-10 border-t border-[#B8CEE5] pt-6">
                    <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-[#12539F]">
                      Tution Fee
                    </p>

                    <p className="mt-2 font-serif text-4xl tracking-tight text-gray-900 sm:text-5xl">
                      ~$49,350
                    </p>
                  </div>
                </div>
              </div>

              {/* Disclaimer */}
              <p className="mt-8 text-center text-sm leading-relaxed text-gray-500">
                Total Cost of Attendance includes tuition, housing, food, fees, and
                other standard living expenses at current Illinois Tech rates.
                Savings ≈ ₹29 Lakh.
              </p>

            </div>
          </div>

          {/* =====================================================
        TOTAL SAVINGS
    ====================================================== */}
          <div className="mt-6 text-center sm:mt-8">

            <p className="text-sm font-medium text-[#64748B]">
              Total Savings
            </p>

            <p
              className="
          mt-1
          text-5xl
          font-medium
          leading-none
          tracking-[-0.04em]
          text-[#12539F]
          sm:text-6xl
          md:text-7xl
        "
            >
              ~$30,500 (≈ INR 29 Lakh*)
            </p>

            <p className="mt-4 text-sm text-[#64748B] sm:text-[15px]">
               up to 30 percent all-in with living costs
            </p>
               <p className="mt-4 text-sm text-[#64748B] sm:text-[15px]">
                *as per current dollar exchange rate.
               </p>

          </div>

          {/* =====================================================
        DIVIDER
    ====================================================== */}
          <div className="mx-auto mt-10 h-[0.5px] max-w-5xl bg-[#D9DEE5] sm:mt-12" />

          {/* =====================================================
        LOAN SUPPORT
    ====================================================== */}
          <div className="mt-10 w-full sm:mt-12">
            {/* SECTION HEADER */}
            <div className="text-center">

              <h3 className="mt-4 text-3xl tracking-tight font-normal text-[#12539F] sm:text-4xl">
                Loan Support
              </h3>

              <p className="mx-auto mt-2 max-w-3xl px-4 text-sm leading-relaxed text-[#64748B] sm:text-[15px]">
                Access flexible financing options and dedicated financial guidance
                through our trusted lending partners.
              </p>
            </div>

            {/* FEATURED PRODIGY FINANCE */}
            <a
              href="https://prodigyfinance.com/ "
              target="_blank"
              rel="noopener noreferrer"
              className="
      group
      mt-7
      flex
      w-full
      flex-col
      items-center
      justify-between
      gap-5
      rounded-2xl
      border-2
      border-[#12539F]/20
      bg-gradient-to-r
      from-[#F0F6FF]
      to-[#F8FAFC]
      px-5
      py-6
      text-center
      transition-all
      duration-300
      hover:-translate-y-0.5
      hover:border-[#12539F]/40
      hover:shadow-lg
      sm:flex-row
      sm:px-8
      sm:py-6
      sm:text-left
    "
            >
              {/* TEXT */}
              <div className="flex-1">
                <div className="flex items-center justify-center gap-2 sm:justify-start">
                  <span className="h-2.5 w-2.5 shrink-0 rounded-full bg-[#EDA12E]" />

                  <p className="text-base font-bold text-[#12539F] sm:text-lg">
                    Collateral-free loan assistance
                  </p>
                </div>


                <p className="mt-2 text-xs leading-relaxed text-[#64748B] sm:ml-[18px] sm:text-sm">
                  Explore financing options designed for students pursuing international
                  education.
                </p>
              </div>

              {/* PRODIGY LOGO */}
              <div
                className="
        flex
        h-16
        min-w-[150px]
        items-center
        justify-center
        rounded-xl
        bg-white
        px-5
        shadow-sm
        sm:h-20
        sm:min-w-[180px]
      "
              >
                <img
                  src="/images/l3.png"
                  alt="Prodigy Finance"
                  className="
          max-h-10
          w-auto
          max-w-[150px]
          object-contain
          transition-transform
          duration-300
          group-hover:scale-105
          sm:max-h-14
          sm:max-w-[170px]
        "
                />
              </div>
            </a>

            {/* OTHER PARTNERS */}
            <div className="mt-8">
              <p className="text-center text-[11px] font-semibold uppercase tracking-[0.16em] text-[#94A3B8] sm:text-xs">
                Additional Lending and Financial Assistance Partners
              </p>

              <div
                className="
        mt-5
        flex
        flex-col
        items-center
        justify-center
        gap-6
        sm:flex-row
        sm:gap-12
      "
              >
                {/* WeMakeScholars */}
                <div className="flex h-12 w-[160px] items-center justify-center">
                  <img
                    src="/images/l1.png"
                    alt="WeMakeScholars"
                    className="max-h-12 max-w-[150px] w-auto object-contain"
                  />
                </div>

                {/* Credila */}
                <div className="flex h-12 w-[160px] items-center justify-center">
                  <img
                    src="/images/l2.png"
                    alt="Credila"
                    className="max-h-10 max-w-[150px] w-auto object-contain"
                  />
                </div>

                <div className="flex h-12 w-[160px] items-center justify-center">
                  <img
                    src="/images/l4.webp"
                    alt="Credila"
                    className="max-h-10 max-w-[150px] w-auto object-contain"
                  />
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default Banner;